let Albums = {
    tracksCount: 0,
    filesCount: 0,

    init: function () {
        this.bind();
    },

    bind: function () {
        this.form();
        this.delete();
        this.aiButtons();
    },

    delete: function () {
        $('.delete-album').click(function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');

            swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this record!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.value) {
                    $.post('/albums/' + id,
                        {
                            _method: 'delete'
                        },
                        (result) => {
                            if (result.success) {
                                let table = row.closest('table').DataTable();
                                table.row(row).remove().draw();
                                swal(
                                    'Deleted!',
                                    'Record has been deleted.',
                                    'success'
                                ).then((result) => {

                                });
                            }
                        });
                }
            });
        });
    },

    form: function () {
        let _this = this;
        const albumForm = $('#albumForm');
        const tracksContainer = $('#tracks');
        const filesContainer = $('#files');
        _this.tracksCount = $('.track').length;
        _this.filesCount = $('.file').length;


        if (albumForm.length) {
            let submitBtn = Ladda.create(albumForm.find('[type=submit]')[0]);

            albumForm.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        toastr.success(response.message);
                        setTimeout(() => {
                            window.location.assign('/albums/' + response.data.id + '/edit');
                        }, 1000);
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });

            $(document).on('click', '.add-track', function () {
                _this.tracksCount++;

                let trackHtml = '<div class="track border-top pt-1">\n' +
                    '                        <div class="form-group">\n' +
                    '                            <label for="trackTitle' + _this.tracksCount + '">Title</label>\n' +
                    '                            <input type="text" class="form-control" name="tracks[' + _this.tracksCount + '][title]" id="trackTitle' + _this.tracksCount + '" value="" placeholder="Title" required>\n' +
                    '                        </div>\n' +
                    '                        <div class="form-group">\n' +
                    '                            <label for="trackDescription' + _this.tracksCount + '">Description</label>\n' +
                    '                            <textarea class="form-control" name="tracks[' + _this.tracksCount + '][description]" id="trackDescription' + _this.tracksCount + '" placeholder="Description"></textarea>\n' +
                    '                        </div>\n' +
                    '                        <div class="form-group">\n' +
                    '                            <label for="trackFileName' + _this.tracksCount + '">File Name</label>\n' +
                    '                            <input type="text" class="form-control" name="tracks[' + _this.tracksCount + '][file_name]" id="trackFileName' + _this.tracksCount + '" value="" placeholder="File Name"" required>\n' +
                    '                        </div>\n' +
                    '                        <div class="form-group">\n' +
                    '                            <label for="trackLength' + _this.tracksCount + '">Length</label>\n' +
                    '                            <input type="text" class="form-control" name="tracks[' + _this.tracksCount + '][length]" id="trackLength' + _this.tracksCount + '" value="" placeholder="Length (IE: 5:15)"" required>\n' +
                    '                        </div>\n' +
                    '                        <div class="form-group">\n' +
                    '                            <button type="button" class="btn btn-danger remove-track">Remove</button>\n' +
                    '                        </div>\n' +
                    '                    </div>';

                tracksContainer.append(trackHtml);
            });

            $(document).on('click', '.remove-track', function () {
                $(this).closest('.track').remove();
            });

            $(document).on('click', '.add-file', function () {
                _this.filesCount++;

                let fileHtml = '<div class="file border-top pt-1">\n' +
                    '                            <div class="form-group">\n' +
                    '                                <label for="fileTitle' + _this.filesCount + '">Title</label>\n' +
                    '                                <input type="text" class="form-control" name="files[' + _this.filesCount + '][title]" id="trackTitle' + _this.filesCount + '" value="" placeholder="Title">\n' +
                    '                            </div>\n' +
                    '                            <div class="form-group">\n' +
                    '                                <label for="trackFile' + _this.filesCount + '">File</label>\n' +
                    '                                <input type="file" class="form-control" name="files[' + _this.filesCount + '][file]" id="trackFile' + _this.filesCount + '">\n' +
                    '                            </div>\n' +
                    '                            <div class="form-group">\n' +
                    '                                <button type="button" class="btn btn-danger remove-file">Remove</button>\n' +
                    '                            </div>\n' +
                    '                        </div>';

                filesContainer.append(fileHtml);
            });

            $(document).on('click', '.remove-file', function () {
                $(this).closest('.file').remove();
            });

            $(document).on('blur', '#albumTitle', function (e) {
                const title = $(this).val();
                const slug = $('#albumSlug');

                if (slug.val() === '') {
                    slug.val(slugify(title));
                }
            });
        }

        $('#albums').on('draw.dt', function () {
            _this.delete();
        });
    },

    aiButtons: function () {
        let addToAiBtn = $(document).find('#addToAiBtn')
        let removeFromAiBtn = $(document).find('#removeFromAiBtn');
        let addToAiLaddaBtn = Ladda.create(addToAiBtn[0]);
        let removeFromAiLaddaBtn = Ladda.create(removeFromAiBtn[0]);

        addToAiBtn.click(function() {
            addToAiLaddaBtn.start();
            window.location = addToAiBtn.attr('href');
        });

        removeFromAiBtn.click(function() {
            swal({
                title: "Are you sure?",
                text: "All AI related data for this album will be removed permanently!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, remove it!"
            }).then((result) => {
                if (result.value) {
                    removeFromAiLaddaBtn.start();
                    window.location = removeFromAiBtn.attr('href');
                }
            });
        });
    }
};

$().ready(function () {
    window.Albums = Albums;
    window.Albums.init();
});
